import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Facebook, Instagram, Youtube, Camera, Heart } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer style={{ background: 'linear-gradient(135deg, #1e1b4b 0%, #4c1d95 40%, #701a75 100%)' }}>
      {/* Colorful top bar */}
      <div className="h-1 w-full bg-gradient-to-r from-primary-400 via-rose-400 via-amber-400 via-emerald-400 to-cyan-400" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="p-2 rounded-xl bg-gradient-to-br from-primary-500 to-violet-600 shadow-lg shadow-primary-500/30">
                <Camera className="h-6 w-6 text-white" />
              </div>
              <p className="text-xl font-bold text-white">AANAND VIDEO COVERAGE</p>
            </div>
            <p className="text-purple-300 mb-6 leading-relaxed">
              Capturing your precious moments with professional photography and videography services.
            </p>
            <div className="flex space-x-3">
              <a
                href="#"
                className="p-2.5 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 text-white hover:scale-110 transition-transform shadow-lg"
                aria-label="Facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="#"
                className="p-2.5 rounded-xl text-white hover:scale-110 transition-transform shadow-lg"
                style={{ background: 'linear-gradient(135deg, #e1306c, #f77737, #fcaf45)' }}
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="#"
                className="p-2.5 rounded-xl bg-gradient-to-br from-red-500 to-red-700 text-white hover:scale-110 transition-transform shadow-lg"
                aria-label="YouTube"
              >
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-lg font-bold mb-5 text-white flex items-center gap-2">
              <span className="w-2 h-6 rounded-full bg-gradient-to-b from-primary-400 to-violet-400 inline-block"></span>
              Quick Links
            </h2>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', to: '/' },
                { label: 'Weddings', to: '/weddings' },
                { label: 'Gallery', to: '/gallery' },
                { label: 'About Us', to: '/about' },
                { label: 'Contact', to: '/contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-purple-300 hover:text-primary-300 transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-400 group-hover:bg-rose-400 transition-colors"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h2 className="text-lg font-bold mb-5 text-white flex items-center gap-2">
              <span className="w-2 h-6 rounded-full bg-gradient-to-b from-rose-400 to-amber-400 inline-block"></span>
              Contact Us
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="p-2 rounded-lg bg-gradient-to-br from-amber-500 to-orange-600 shadow-md flex-shrink-0">
                  <Phone className="h-4 w-4 text-white" />
                </div>
                <a href="tel:9842489313" className="text-purple-300 hover:text-amber-300 transition-colors pt-1">
                  9842489313
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="p-2 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-600 shadow-md flex-shrink-0">
                  <MapPin className="h-4 w-4 text-white" />
                </div>
                <span className="text-purple-300 pt-1">
                  Santhanathapuram, Pudukkottai,<br />
                  Tamil Nadu 622001
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-8 text-center">
          <p className="text-purple-400 flex items-center justify-center gap-2 text-sm">
            &copy; {new Date().getFullYear()} AANAND VIDEO COVERAGE. Made with
            <Heart className="h-4 w-4 text-rose-400 fill-rose-400" />
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
